import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/data/manually-managed");

export const Route = createFileRoute("/data/manually-managed")({
  head: () => ({
    meta: [
      { title: "Manually managed data — LevelLoad" },
      { name: "description", content: "Reference data and planning rules managed in LevelLoad." },
      { property: "og:title", content: "Manually managed data — LevelLoad" },
      {
        property: "og:description",
        content: "Reference data and planning rules managed in LevelLoad.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
